import { Pie } from "@ant-design/plots";
import React, { useState, useEffect, useRef, useMemo } from "react";
import * as echarts from 'echarts';
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import { dashboardApi } from "services/dashboardService";
import { decodeJWT } from "common/functions";
import "./Connectors.less";
import { emailToUsername } from "common/utils";
import { Table, Divider } from 'antd';

type Props = {
	title?: string;
	connectorsData: { type: string, value: number }[];
	SummaryForAll?: any;
	shouldRefresh?: boolean;
	summaryForStationV2?: any;
};

const Connectors: React.FC<Props> = ({ title, shouldRefresh, connectorsData, SummaryForAll, summaryForStationV2 }) => {

	const dispatch = useDispatch();
	const pieCharts = useRef(null);
	const [pieContent, setPieContent] = useState<any[]>([])
	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);
	const { stationId } = useSelector(
		(state: rootReducerType) => state.stationIdReducer
	);
	const params = {
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
	};

	const [myChart, setMyChart] = useState<any>(null)
	const [pieKeyData, setPieKeyData] = useState<any[]>([
		'Available', 'In Use', 'Available', 'In Use', 'Available', 'In Use'
	])
	const [pieDetails, setPieDetials] = useState<any[]>([])

	useEffect(() => {

		dispatch(
			dashboardApi.endpoints.getConnectorSummary.initiate(
				{ userName: params.userName },
				{ subscribe: false, forceRefetch: true }
			)
		);
	}, [shouldRefresh, dispatch, params.userName]);

	useEffect(() => {
		if (!stationId && SummaryForAll) {
			let statusDetailsKeys = Object.keys(SummaryForAll.statusDetails)
			setPieDetials(statusDetailsKeys)
		} else if (stationId && summaryForStationV2) {
			let statusDetailsKeys = Object.keys(summaryForStationV2.statusDetails)
			setPieDetials(statusDetailsKeys)
		}

		if (!stationId) {
			if (pieCharts.current && SummaryForAll) {
				if (!myChart) {
					initCharts(SummaryForAll);
				} else {
					updateCharts(myChart, SummaryForAll)
				}
			}
		} else if(stationId && summaryForStationV2) {
			if (!myChart) {
				initCharts(summaryForStationV2);
			}
			summaryForStationV2 && updateCharts(myChart, summaryForStationV2)
		}

		return () => {
			if (myChart) {
				myChart.off('click', echartsClick);
			}
		}
	}, [SummaryForAll, summaryForStationV2])

	const legendColors = [
		// "inherit",
		"#9DCC78",
		"#E088FF",
		"#FED077",
		"#CECECE",
		"#FF7866",
		"#9DCC78"
	];

	const config = {
		appendPadding: 10,
		padding: 15,
		data: connectorsData.slice(1),
		angleField: "value",
		colorField: "type",
		color: legendColors.slice(1),
		label: {
			type: "inner",
			style: {
				fontSize: 0,
			},
		},
		radius: 1,
		interactions: [
			{
				type: "element-active",
			},
		],
	};

	const [pieItemName, setPieItemName] = useState<string>("")

	const echartsClick = (params: any) => {
		if (params.seriesType === 'pie') {
			// 此处可以根据params.name或其他信息处理点击事件
			setPieItemName(params.name)
			setIsOpen(true)
		}
	}

	const initCharts = (SummaryForAll) => {
		var chartDom = pieCharts.current;
		var myChart = echarts.init(chartDom);
		setMyChart(myChart)
		updateCharts(myChart, SummaryForAll);
		// 为图表添加点击事件监听器
		myChart.on('click', echartsClick)
	}

	const updateCharts = (myChart, pieDatas) => {
		type EChartsOption = echarts.EChartsOption;
		var option: EChartsOption;
		option = {
			// tooltip: {
			// 	trigger: 'item'
			// },
			// graphic: [
			// 	{
			// 		type: 'text',
			// 		left: 'center',
			// 		top: '42%',
			// 		style: {
			// 		  text: '16',
			// 		  fill: '#000',
			// 		  width: 30,
			// 		  height: 30,
			// 		  fontSize: 20
			// 		}
			// 	},
			// 	{
			// 		type: 'text',
			// 		left: 'center',
			// 		top: '52%',
			// 		style: {
			// 		  text: 'total',
			// 		  fill: '#000',
			// 		  width: 30,
			// 		  height: 30,
			// 		  fontSize: 14
			// 		}
			// 	}
			// ],
			series: [
				{
					name: 'Access From',
					type: 'pie',
					radius: ['40%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 10,
						borderColor: '#fff',
						borderWidth: 2
					},
					label: {
						show: false,
						position: 'center',
						// formatter: '{b}: {d}'
					},
					emphasis: {
						disabled: false,
						label: {
							show: true,
							fontSize: 16,
							fontWeight: 'bold',
							overflow: 'break',
							formatter: '{b}: {c}'
						},
					},
					labelLine: {
						show: false
					},
					data: [
						{ value: 1048, name: 'Available' },
						{ value: 735, name: 'In use' },
						{ value: 580, name: 'Unavailable' },
						{ value: 484, name: 'Office' },
						{ value: 300, name: 'Faullted' }
					]
				}
			]
		};

		let pieArr = pieDatas.statusCounts
		let pieKeyArr = Object.keys(pieArr)
		pieKeyArr = pieKeyArr.filter(item => {
			return item !== 'Total'
		})
		setPieKeyData(pieKeyArr)
		let pieArrData = pieKeyArr.map((item, index) => {
			return {
				name: item,
				value: pieArr[item],
				itemStyle: {
					color: legendColors[index]
				}
			}
		})
		if (option.series) option.series[0].data = pieArrData
		option && myChart && myChart.setOption(option);
	}

	const [isOpen, setIsOpen] = useState<boolean>(false)

	// 添加点击事件处理程序
	const handleOutsideClick = (e) => {
		if (isOpen && !e.target.closest('.pie-popup') && !e.target.closest('.pieCharts')) {
			// 如果点击的区域不在弹窗内部，则关闭弹窗
			setIsOpen(false);
		}
	};

	// 在组件挂载时添加全局点击事件监听器
	useEffect(() => {
		document.addEventListener('click', handleOutsideClick);
		return () => {
			// 在组件卸载时移除监听器
			document.removeEventListener('click', handleOutsideClick);
		};
	}, [isOpen]);

	// 创建事件处理函数
    const resizeChart = function () {
        if (myChart) {
            myChart.resize(); // 调整图表大小以适应新的窗口大小
        }
    };

    useEffect(() => {
        // 监听窗口大小变化事件
        window.addEventListener('resize', resizeChart)
        return () => {
            window.removeEventListener('resize', resizeChart);
        }
    }, [myChart])

	const popupLi = (SummaryForData) => {
		if(pieItemName == "Total") {
			return (
				<>
					{/* {
						SummaryForData && pieDetails && pieDetails.map((item, index) => {
							return (<div key={index} className="pie-popup-detail">
								<div className="pie-popup-detail-title">{item}</div>
								<div className="pie-popup-detail-list">
									{
										SummaryForData.statusDetails[item].map((it, idx) => {
											return <div key={idx} className="pie-popup-detail-list-item">{it}</div>
										})
									}
								</div>
							</div>)
						})
					} */}
				</>
			)
		}else{
			return (
				<>
					{
						SummaryForData && pieDetails && pieDetails.map((item, index) => {
							return (pieItemName == item) && (<div key={index} className="pie-popup-detail">
								<div className="pie-popup-detail-title">{item}</div>
								<div className="pie-popup-detail-list">
									{
										SummaryForData.statusDetails[item].map((it, idx) => {
											return <div key={idx} className="pie-popup-detail-list-item">{it}</div>
										})
									}
								</div>
							</div>)
						})
					}
				</>
			)
		}
		
	}

	return (
		// <section className="pie-container">
		// 	<div className="title">{title}</div>
		// 	<section className="pie-details">
		// 		<section className="pie-legend">
		// 			{connectorsData.map((obj, index) => {
		// 				return (
		// 					<div className="legend-item" key={index}>
		// 						<div
		// 							className="item-color"
		// 							style={{ backgroundColor: legendColors[index] }}
		// 						></div>
		// 						<div className="item-title">{obj.type}</div>
		// 						<div className="item-value">{obj.value}</div>
		// 					</div>
		// 				);
		// 			})}
		// 		</section>
		// 		<Pie {...config} style={{ width: "50%" }} legend={false} />
		// 	</section>
		// </section>
		<section className="pie-container">
			<div className="title">{title}</div>
			<div className="pie-container-content">
				<div className="pieCharts" ref={pieCharts}></div>
				<div className="pieContent">
					<div className="pieContent-title">
						<div className="pieContent-title-perch">占位</div>
						<div className="pieContent-title-center">Connectors</div>
						{/* <div className="pieContent-title-right">Title</div> */}
					</div>
					{!stationId && pieKeyData.map((item, index) => {
						return (
							<div key={index} className="pieContent-content">
								<div className="pieContent-content-left">
									<div className="pieContent-content-left-li"
										style={{ 'background': legendColors[index] }}></div>
									<div className="pieContent-content-left-text">{item}</div>
								</div>
								<div className="pieContent-content-center">{SummaryForAll && SummaryForAll.statusCounts[item]}</div>
								{/* <div className="pieContent-content-right">36%</div> */}
							</div>
						)
					})}
					{stationId && pieKeyData.map((item, index) => {
						return (
							<div key={index} className="pieContent-content">
								<div className="pieContent-content-left">
									<div className="pieContent-content-left-li"
										style={{ 'background': legendColors[index] }}></div>
									<div className="pieContent-content-left-text">{item}</div>
								</div>
								<div className="pieContent-content-center">{summaryForStationV2 && summaryForStationV2.statusCounts[item]}</div>
								{/* <div className="pieContent-content-right">36%</div> */}
							</div>
						)
					})}
				</div>
			</div>
			<div className="pie-popup" style={{ 'display': (isOpen ? 'block' : 'none') }}>
				<div className="pie-popup-li">
					{!stationId ? popupLi(SummaryForAll) : popupLi(summaryForStationV2)}
				</div>
			</div>
		</section >
	);
};

export default Connectors;
